import { Component, OnInit } from '@angular/core';
import { ModalService } from 'ng-bootstrap-modal';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  param:any;
  cancellationReason:any;
  constructor(private modalService:ModalService,private _analyticsService: AnalyticsService) { }
  ngOnInit() {    
    this.param = this.modalService.getValue()
  }

  submit(cancellationReason) {    
    this.modalService.ok();  
    cancellationReason = cancellationReason==undefined?null:cancellationReason;
    this._analyticsService.cancelAppointments(this.param,cancellationReason).subscribe(
      data => {
          if (data.returnCode == 0) {
              alert("Appointment Cancelled sucessfully")                                   
          }
          else {
              alert(data.returnMsg)             
  
          }
      },
      error => {
          // this.alertService.error(error);
          // this.loading = false;         
          alert(error)
          console.log(error)
      });
}
cancel() {
    this.modalService.cancel();
}

  

}



// WEBPACK FOOTER //
// ./src/app/shared/dialog/dialog.component.ts